import { SET_PARAM } from '../types'

const initialState = {
  major: -1,
  period: -1,
  documentation: -1,
  enroll: -1, 
  belate: -1,
  responsible: -1,
  date: -1,
  documentPending: -1
}

export const exportDocumentReducer = (state = initialState, action) => {
  switch (action.type) {

    case SET_PARAM:
      return {
        ...state,
        ...action.param
      }
  
    default:
      return state
  }
}